import { useEffect } from "react";
// import cargandoCard from "../../components/cargando-card";
// import sinAccesoCard from "../../components/sin-acceso-card";
import Modulo from "../../components/modulo";
import { useModulesAdmin } from "./modules_admin";
import { useModulesAdminGroup } from "./modules_admin";

export default function ManageScreen() {

    const MODULES_ADMIN = useModulesAdmin();
    const GRUPOS_ADMINSTRACION = useModulesAdminGroup();
    // const [cargandoPage, setCargandoPage] = useState(true);
    // const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            // setCargandoPage(false);
            // setTieneAccesoAlModulo(true);
        } catch (err) {
            // setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    }

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="p-4">
                    <div className="w-full">
                        <div className="w-full mb-4 ml-4">
                            <h2 className="text-lg font-bold">{GRUPOS_ADMINSTRACION.ADMIN}</h2>
                        </div>
                        <div className="flex flex-wrap gap-4">
                            {MODULES_ADMIN
                                .filter(e => e.grupo === GRUPOS_ADMINSTRACION.ADMIN)
                                .map((data) => Modulo(data))
                            }
                        </div>
                    </div>
                    <hr />
                    <div className="w-full">
                        <div className="w-full mb-4 ml-4">
                            <h2 className="text-lg font-bold">{GRUPOS_ADMINSTRACION.VEHICLE}</h2>
                        </div>
                        <div className="flex flex-wrap gap-4">
                            {MODULES_ADMIN.filter(e => e.grupo === GRUPOS_ADMINSTRACION.VEHICLE).map((data) => Modulo(data))}
                        </div>
                    </div>
                    <hr />
                    <div className="w-full">
                        <div className="w-full mb-4 ml-4">
                            <h2 className="text-lg font-bold">{GRUPOS_ADMINSTRACION.PROVIDER}</h2>
                        </div>
                        <div className="flex flex-wrap gap-4">
                            {MODULES_ADMIN.filter(e => e.grupo === GRUPOS_ADMINSTRACION.PROVIDER).map((data) => Modulo(data))}
                        </div>
                    </div>
                    <hr />
                    <div className="w-full">
                        <div className="w-full mb-4 ml-4">
                            <h2 className="text-lg font-bold">{GRUPOS_ADMINSTRACION.USER}</h2>
                        </div>
                        <div className="flex flex-wrap gap-4">
                            {MODULES_ADMIN.filter(e => e.grupo === GRUPOS_ADMINSTRACION.USER).map((data) => Modulo(data))}
                        </div>
                    </div>
                    <hr />
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};
